import React, { useState } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import config from "../../Config";
import FeeSystemMenu from "./FeeSystemMenu";

function ChangeScrollDate() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const userGroupId = localStorage.getItem("User_Group_ID");
  const canReversePosted = userGroupId === "1" || userGroupId === "13";

  const [RegistrationNo, setRegistrationNo] = useState("");
  const [StudentID, setStudentID] = useState("");
  const [ChallanNo, setChallanNo] = useState("");
  const [NewDate, setNewDate] = useState(moment().format("YYYY-MM-DD"));

  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [reversing, setReversing] = useState(false);
  const [showReverseModal, setShowReverseModal] = useState(false);
  const [record, setRecord] = useState(null);

  const getPayload = () => ({
    AccessKey,
    UserID,
    MemberType,
    Registration_No: RegistrationNo.trim(),
    Student_ID: parseInt(StudentID, 10) || 0,
    ChallanNo: ChallanNo.trim(),
  });

  const fetchDetails = async () => {
    if (!ChallanNo.trim()) {
      toast.error("Please enter challan number.");
      return;
    }

    setLoading(true);
    setRecord(null);
    try {
      const response = await axios.post(
        `${config.base_url}ScrollEntry/GetScrollDateChangeDetails`,
        getPayload(),
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data?.status_code === 1) {
        setRecord(response.data.Record);
        if (response.data.Record?.Scroll_Dated) {
          setNewDate(moment(response.data.Record.Scroll_Dated).format("YYYY-MM-DD"));
        }
      } else {
        toast.error(response.data?.status_message || "No record found.");
      }
    } catch {
      toast.error("Network Error..");
    } finally {
      setLoading(false);
    }
  };

  const updateDate = async () => {
    if (!record) {
      toast.error("Please fetch challan details first.");
      return;
    }
    if (!NewDate) {
      toast.error("Please select new date.");
      return;
    }

    setUpdating(true);
    try {
      const response = await axios.post(
        `${config.base_url}ScrollEntry/UpdateScrollDate`,
        {
          ...getPayload(),
          Dated: NewDate,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data?.status_code === 1) {
        toast.success(response.data?.status_message || "Updated successfully.");
        fetchDetails();
      } else {
        toast.error(response.data?.status_message || "Update failed.");
      }
    } catch {
      toast.error("Network Error..");
    } finally {
      setUpdating(false);
    }
  };

  const reverseScrollEntry = async () => {
    if (!record?.Entry_Id) {
      toast.error("No scroll entry found to reverse.");
      return;
    }

    setReversing(true);
    try {
      const response = await axios.post(
        `${config.base_url}ScrollEntry/ReversePostedScrollEntry`,
        getPayload(),
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data?.status_code === 1) {
        toast.success(response.data?.status_message || "Scroll entry reversed.");
        setShowReverseModal(false);
        setRecord(null);
      } else {
        toast.error(response.data?.status_message || "Reversal failed.");
      }
    } catch {
      toast.error("Network Error..");
    } finally {
      setReversing(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <FeeSystemMenu />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/FeeSystem/FeeSystemDashboard">Fee System</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Change Scroll Date
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Change Scroll / Deposit Date</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card mb-2">
              <div className="card-body">
                <div className="row align-items-end">
                  <div className="col-md-3">
                    <label>Registration No</label>
                    <input
                      type="text"
                      className="form-control"
                      value={RegistrationNo}
                      onChange={(e) => setRegistrationNo(e.target.value)}
                      placeholder="Optional filter"
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Student ID</label>
                    <input
                      type="number"
                      min="0"
                      className="form-control"
                      value={StudentID}
                      onChange={(e) => setStudentID(e.target.value)}
                      placeholder="Optional filter"
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Challan Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={ChallanNo}
                      onChange={(e) => setChallanNo(e.target.value)}
                      placeholder="Required"
                    />
                  </div>
                  <div className="col-md-3">
                    <button className="button button-primary w-100" onClick={fetchDetails} disabled={loading}>
                      {loading ? "Loading..." : "Fetch Details"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {record && (
              <>
                <div className="card mb-2">
                  <div className="card-body">
                    <table className="table table-theme mb-0">
                      <thead>
                        <tr>
                          <th>Student ID</th>
                          <th>Reg No</th>
                          <th>Student Name</th>
                          <th>Father Name</th>
                          <th>Challan No</th>
                          <th>Receipt No</th>
                          <th>Amount Deposited</th>
                          <th>Posted In Ledger</th>
                          <th>Challan Status</th>
                          <th>Bank Scroll Date</th>
                          <th>ADLedger Received</th>
                          <th>Scroll Entry Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{record.Student_ID}</td>
                          <td>{record.Registration_No}</td>
                          <td>{record.Student_Name}</td>
                          <td>{record.Father_Name}</td>
                          <td>{record.Challan_No}</td>
                          <td>{record.Receipt_No || "-"}</td>
                          <td>{record.Amount_Deposited}</td>
                          <td>{record.Posted_In_Ledger ? "Yes" : "No"}</td>
                          <td>{record.Is_Paid ? (record.VoucherStatus || "Paid") : "UnPaid"}</td>
                          <td>{record.Bank_Scroll_Date ? moment(record.Bank_Scroll_Date).format(config.date_format) : "-"}</td>
                          <td>{record.Ledger_ReceivedDate ? moment(record.Ledger_ReceivedDate).format(config.date_format) : "-"}</td>
                          <td>{record.Scroll_Dated ? moment(record.Scroll_Dated).format(config.date_format) : "-"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="card mb-2">
                  <div className="card-body">
                    <h5 className="mb-3">Change Deposit Date</h5>
                    <p className="text-muted small">
                      Only available for paid challans that have already been posted to the ledger.
                    </p>
                    <div className="row align-items-end">
                      <div className="col-md-3">
                        <label>New Deposit Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={NewDate}
                          onChange={(e) => setNewDate(e.target.value)}
                          disabled={!record.Is_Paid}
                        />
                      </div>
                      <div className="col-md-3">
                        <button
                          className="button button-primary w-100"
                          onClick={updateDate}
                          disabled={updating || !record.Is_Paid}
                        >
                          {updating ? "Updating..." : "Update Date"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {canReversePosted && record.Entry_Id > 0 && (
                  <div className="card border-danger">
                    <div className="card-body">
                      <h5 className="mb-2 text-danger">Reverse Scroll Entry</h5>
                      <p className="text-muted small mb-3">
                        Use this when a bank scroll was posted against the wrong student/challan.
                        {record.Posted_In_Ledger
                          ? " This will delete the scroll entry, mark the challan unpaid, and restore pending amounts in tblADLedger (same scope as Post Entries into Ledger)."
                          : " This will remove the unposted scroll entry only."}
                      </p>
                      <button
                        type="button"
                        className="button button-outline-danger"
                        onClick={() => setShowReverseModal(true)}
                        disabled={reversing}
                      >
                        Reverse Scroll Entry
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}

            {(loading || updating || reversing) && (
              <div className="text-center mt-3">
                <Spinner animation="border" role="status"></Spinner>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal show={showReverseModal} onHide={() => !reversing && setShowReverseModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Scroll Reversal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {record && (
            <>
              <p>
                Reverse scroll entry for challan <strong>{record.Challan_No}</strong> (student{" "}
                <strong>{record.Student_Name}</strong>, ID {record.Student_ID})?
              </p>
              {record.Posted_In_Ledger ? (
                <ul className="mb-0">
                  <li>Delete scroll entry #{record.Entry_Id}</li>
                  <li>Set challan status back to <strong>UnPaid</strong></li>
                  <li>Restore tblADLedger lines to pending (clear received amounts/dates)</li>
                  <li>Remove unused advance fee (023) rows created during posting, if any</li>
                </ul>
              ) : (
                <p className="mb-0">This will delete the unposted scroll entry only.</p>
              )}
              <p className="text-muted small mt-3 mb-0">
                Published result cards are not changed. Registration numbers assigned during posting are not reverted.
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="button button-white"
            onClick={() => setShowReverseModal(false)}
            disabled={reversing}
          >
            Cancel
          </button>
          <button
            type="button"
            className="button button-primary"
            onClick={reverseScrollEntry}
            disabled={reversing}
          >
            {reversing ? "Reversing..." : "Confirm Reverse"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ChangeScrollDate;
